import URLS from "@api/constants/urls";
import {
  handleGlobalPatchRequest,
  handleGlobalPostRequest,
} from "@api/functions/changeRequests";
import { handleNetworkError, handleSuccessToast } from "@repo/ui/libs";
import { useMutation } from "@tanstack/react-query";
import {
  IIcApiConfigResponseSchema,
  IIcApiConfigSubmitSchema,
} from "./icApiConfiguratorApi.types";

const useAddIcApiConfigMuation = () => {
  return useMutation<
    IIcApiConfigResponseSchema,
    Error,
    IIcApiConfigSubmitSchema
  >({
    mutationFn: (data) => {
      return handleGlobalPostRequest({
        url: URLS.IC_API_CONFIG,
        data,
      });
    },

    onError: handleNetworkError,

    onSuccess: () =>
      handleSuccessToast({
        message: "Configuration added successfully",
      }),
  });
};

const useUpdateIcApiConfigMuation = () => {
  return useMutation<
    IIcApiConfigResponseSchema,
    Error,
    IIcApiConfigSubmitSchema
  >({
    mutationFn: (data) => {
      return handleGlobalPatchRequest({
        url: `${URLS.IC_API_CONFIG}/${data?.id}`,
        data,
      });
    },

    onError: handleNetworkError,

    onSuccess: () =>
      handleSuccessToast({
        message: "Configuration updated successfully",
      }),
  });
};

export { useAddIcApiConfigMuation, useUpdateIcApiConfigMuation };
